var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.User.user.role)?_c('div',{staticClass:"show-box body-box scroll-y info-container bg-white min-body-height"},[_c('Default'),_vm._v(" "),_c('UserInfo'),_vm._v(" "),_c('OrgInfo'),_vm._v(" "),(_vm.User.user.role == _vm.$roleConsts.ORG.value)?_c('OrgPlayer'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c436a436","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/info/index.vue
// module id = null
// module chunks = 